const ASSESSABLE_STATES = new Set(['checking', 'action_required', 'confirmation_required', 'awaiting_admin_review', 'approved']);

export function employmentComparisonSourceState(snapshot) {
  const integrity = snapshot?.employment_integrity;
  const state = integrity?.state;
  if (!integrity || state === 'error' || !state || (!ASSESSABLE_STATES.has(state) && state !== 'not_ready')) {
    return { mode: 'unavailable', title: 'Employment comparison unavailable', description: 'A current check result is not available. Refresh the record before completing the review.' };
  }
  if (state === 'not_ready' || snapshot?.work_history?.state !== 'complete' || snapshot?.cv?.view_available !== true || !Array.isArray(integrity.prerequisites_missing) || integrity.prerequisites_missing.length > 0) {
    return { mode: 'pending', title: 'CV and work history not yet assessed', description: 'Follow the missing-record actions above. This comparison has not produced a clear result yet.' };
  }
  if (integrity.needs_evaluation === true && state !== 'checking') {
    return { mode: 'pending', title: 'Employment comparison needs a current check', description: 'The saved result is not current. Recheck the latest information before completing the review.' };
  }
  return { mode: 'assessable' };
}

export default function EmploymentComparisonPendingNotice({ status }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4" data-testid="employment-comparison-pending">
      <p className="text-sm font-semibold text-slate-900">{status?.title || 'Employment checks need attention'}</p>
      <p className="mt-1 text-sm text-slate-600">{status?.description || 'The current check is incomplete. Follow the outstanding actions before completing the review.'}</p>
    </div>
  );
}
